// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_FIWTp","bonus-products-wrap":"bonus-products-wrap_Wmp8N","swiper":"swiper_zzVIT"};